import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

const routes: Routes = [
  {
    path: 'exchange-secure-payment',
    // loadChildren: () => import('./exchange-secure-payment/exchange-secure-payment.module').then(m => m.ExchangeSecurePaymentModule)
    redirectTo: '/pro',
  },
  {
    path: '',
    loadChildren: () => import('./professional/professional.module').then(m => m.ProfessionalModule)
  },
];

@NgModule({
  imports: [
    LocalizeRouterModule.forChild(routes),
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
    LocalizeRouterModule,
  ],
})
export class ProRoutingModule {
}
